import React from 'react';
import UIModelTable from "../../components/UIModelTable/UIModelTableI";
import {TParty} from "../../../../../../types/Context/AppContext";

type ModelListProps = {
    id?: string;
    projectId: string;
    userProjectDataModels: any;
    selectedParty: TParty;
}

export const ModelList = ({id, projectId, userProjectDataModels, selectedParty}: ModelListProps) => {
    return (
        <>
            <div className='tw-w-full'>
                {/* Model List Implementation */}
                <UIModelTable projectId={projectId} selectedParty={selectedParty}/>
            </div>
        </>
    );
};